import React from "react";
import "./NoJobs.css";
import sadIcon from "../../../../assets/icons/sad.svg";
import fb from "../../../../assets/icons/social1.svg";
import ig from "../../../../assets/icons/social2.svg";
import li from "../../../../assets/icons/social3.svg";
import xIcon from "../../../../assets/icons/social4.svg";

const NoJobs = () => {
  return (
    <section className="noJobs" aria-label="No open jobs">
      <div className="noJobs-empty">
        <div className="sadholder">
          <img src={sadIcon} alt="" className="noJobs-sadIcon" aria-hidden />
        </div>
        <p className="noJobs-title">There are no open roles at the moment.</p>
        <p className="noJobs-subtitle">
          Follow us for updates on new opportunities or subscribe to be notified.
        </p>

        <div className="noJobs-subscribe">
          <input
            type="email"
            placeholder="Enter your email and be notified for new roles"
            aria-label="Email for role updates"
          />
          <button type="button">Subscribe</button>
        </div>
      </div>

      <div className="noJobs-social">
        <p>Follow us on social media</p>
        <div className="noJobs-socialList">
          <a href="https://www.facebook.com/irqgyp" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <img src={fb} alt="" aria-hidden />
          </a>
          <a href="https://www.instagram.com/irqgyp" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <img src={ig} alt="" aria-hidden />
          </a>
          <a href="https://www.linkedin.com/company/irqgyp" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <img src={li} alt="" aria-hidden />
          </a>
          <a href="https://x.com/irqgyp" target="_blank" rel="noopener noreferrer" aria-label="X">
            <img src={xIcon} alt="" aria-hidden />
          </a>
        </div>
      </div>
    </section>
  );
};

export default NoJobs;
